var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.72 16.0499C21.72 18.9199 19.4 21.2399 16.53 21.2399C13.66 21.2399 11.34 18.9199 11.34 16.0499C11.34 13.1799 13.66 10.8599 16.53 10.8599C19.4 10.8599 21.72 13.1799 21.72 16.0499Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.53 17.62C17.3971 17.62 18.1 16.9171 18.1 16.05C18.1 15.1829 17.3971 14.48 16.53 14.48C15.6629 14.48 14.96 15.1829 14.96 16.05C14.96 16.9171 15.6629 17.62 16.53 17.62Z",
    fill: "#00C9B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.77 38.05C16.21 38.42 16.85 38.42 17.29 38.05C20.3 35.52 31.19 25.7 31.19 16.31C31.19 8.38997 24.63 1.97998 16.53 1.97998C8.43 1.97998 1.87 8.39997 1.87 16.31C1.87 25.7 12.76 35.51 15.76 38.05",
    stroke: "#2E63EE",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.77 38.05C16.21 38.42 16.85 38.42 17.29 38.05C20.3 35.52 31.19 25.7 31.19 16.31C31.19 8.38997 24.63 1.97998 16.53 1.97998C8.43 1.97998 1.87 8.39997 1.87 16.31C1.87 25.7 12.76 35.51 15.76 38.05H15.77Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64001 40.03H24",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMarker);
export default __webpack_public_path__ + "static/media/blue-marker.7ac0ea2c8b1b3e50d3c274d5e9ccec54.svg";
export { ForwardRef as ReactComponent };